/**
 * orga-app-api - pandemie-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AufgabePandemieLevelInfo { 
    aufgabe_id: string;
    ist_zugeordnet?: boolean;
    level_id?: number;
}

